import { createAction, props } from '@ngrx/store';
import { IErrorLog } from '../../../../model/error-logs';
import { ILocationContext } from '../../../../model/location-context';

// Links
export const requestErrorLogs = createAction(
    '[Error Logs] Request Error Logs',
    props<{ locationContext: ILocationContext }>()
);

export const loadErrorLogs = createAction('[Error Logs] Load Error Logs', props<{ errorLogs: IErrorLog[] }>());
